import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { PageBanner } from "../components/PageBanner";
import { CTABand } from "../components/CTABand";
import { CareProcess } from "../components/home/CareProcess";

export default function CareProcessPage() {
  return (
    <div data-testid="care-process-page">
      <Header />
      <main>
        <PageBanner
          testId="care-process-banner"
          eyebrow="How We Work"
          title="Our Care Process"
          description="Six thoughtful steps — from your first free consultation to ongoing quality reviews — designed to make starting care simple, personal, and reassuring."
        />
        <CareProcess />
        <CTABand />
      </main>
      <Footer />
    </div>
  );
}
